<mat-dialog-actions class="action-add-header">
    <img class="imgResponseAdd" src="../../../../../../assets/images/ChatDots.svg">
    <div class="titleResponse">
        <span class="title"> Create New Response<app-guide-tooltip tooltipText="Learn how to create and manage responses"
                        docSection="23-toc-title">
                                </app-guide-tooltip></span>
        <span class="subTitle"> Please enter a name for the response.</span>
    </div>
    <button class="mat-button" style="color: #667085; outline: none;" (click)="onCloseClick()">
        <mat-icon>close</mat-icon></button>


</mat-dialog-actions>

<mat-dialog-content class="paddTop0">
    <ng-container *ngIf="!typeFollowUp && !typeMarketing">
        <app-add-action [intention]='intention' [botType]="botType" [promptList]="promptList" [isTheme]='isTheme'
            [builtTemplate]="builtTemplate" [built]='built' [show]='show' [event]='event' [idBOT]="idBOT"
            [dialogRef]="DialogRef" [parent]="parent" [suggestName]="suggestName"
            [flowName]="flowName"></app-add-action>
    </ng-container>
    <!--ng-container *ngIf="typeFollowUp">
        <app-add-follow-up [isTheme]='isTheme' [idBOT]="idBOT" [dialogRef]="DialogRef" [botType]="botType"
            [parent]="parent" [suggestName]="suggestName"></app-add-follow-up>
    </ng-container-->

    <!-- <ng-container *ngIf="typeMarketing">
        <app-add-marketing-messages [isTheme]='isTheme' [idBOT]="idBOT" [dialogRef]="DialogRef" [botType]="botType"
            [parent]="parent" [suggestName]="suggestName"></app-add-marketing-messages>
    </ng-container> -->
</mat-dialog-content>